import styled from '@emotion/styled';
import { ChevronRightIcon, MusicNoteIcon } from '@imus/base-ui';
import { BodyS, ContentM } from '@imus/services-ui/src/Text';
import { Button, Card, CardOption, H3, H4 } from 'imdui';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

const StyledCard = styled(Card)`
  padding: 32px;
`;

const ProgrssSectionStyled = styled.div`
  width: 100%;
  border-radius: 1px;
  background: var(--outline-var);
  height: 2px;
`;

const CompletedSectionStyled = styled(ProgrssSectionStyled)`
  background: var(--accent, #4fc100);
`;

const Dot = styled.div`
  width: 100%;
  aspect-ratio: 1/1;
  border-radius: 50%;
  background: var(--accent);
`;

const ProgressLine = styled.div`
  display: grid;
  margin: 32px 0;
  align-items: center;
  grid-template-columns: 4px 1fr 8px 1fr 4px 1fr 4px 1fr 4px;
`;

const DisabledDot = styled(Dot)`
  background: var(--outline);
`;

const Progress = () => {
  return (
    <ProgressLine>
      <Dot />
      <CompletedSectionStyled />
      <Dot />
      <ProgrssSectionStyled />
      <DisabledDot />
      <ProgrssSectionStyled />
      <DisabledDot />
      <ProgrssSectionStyled />
      <DisabledDot />
    </ProgressLine>
  );
};

const ThankYouSection = styled.div`
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid var(--fg-4, rgba(0, 0, 0, 0.1));
`;

const NextStepsSection = styled.div`
  gap: 16px;
  display: grid;
`;

const viewdesktop = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V12.2C2 13.8802 2 14.7202 2.32698 15.362C2.6146 15.9265 3.07354 16.3854 3.63803 16.673C4.27976 17 5.11984 17 6.8 17H11V19H8C7.44772 19 7 19.4477 7 20C7 20.5523 7.44772 21 8 21H16C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19H13V17H17.2C18.8802 17 19.7202 17 20.362 16.673C20.9265 16.3854 21.3854 15.9265 21.673 15.362C22 14.7202 22 13.8802 22 12.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803ZM17.2 5H6.8C5.92692 5 5.39239 5.00156 4.99247 5.03423C4.80617 5.04945 4.69345 5.06857 4.625 5.08469C4.59244 5.09236 4.57241 5.09879 4.56158 5.10265C4.55118 5.10636 4.54601 5.10899 4.54601 5.10899C4.35785 5.20487 4.20487 5.35785 4.10899 5.54601C4.10899 5.54601 4.10636 5.55118 4.10265 5.56158C4.09879 5.57241 4.09236 5.59244 4.08469 5.625C4.06857 5.69345 4.04945 5.80617 4.03423 5.99247C4.00156 6.39239 4 6.92692 4 7.8V12.2C4 13.0731 4.00156 13.6076 4.03423 14.0075C4.04945 14.1938 4.06857 14.3065 4.08469 14.375C4.09236 14.4076 4.09879 14.4276 4.10265 14.4384C4.10636 14.4488 4.10899 14.454 4.10899 14.454C4.20487 14.6422 4.35785 14.7951 4.54601 14.891C4.54601 14.891 4.55118 14.8936 4.56158 14.8973C4.57241 14.9012 4.59244 14.9076 4.625 14.9153C4.69345 14.9314 4.80617 14.9505 4.99247 14.9658C5.39239 14.9984 5.92692 15 6.8 15H17.2C18.0731 15 18.6076 14.9984 19.0075 14.9658C19.1938 14.9505 19.3065 14.9314 19.375 14.9153C19.4076 14.9076 19.4276 14.9012 19.4384 14.8973C19.4488 14.8936 19.454 14.891 19.454 14.891C19.6422 14.7951 19.7951 14.6422 19.891 14.454C19.891 14.454 19.8936 14.4488 19.8973 14.4384C19.9012 14.4276 19.9076 14.4076 19.9153 14.375C19.9314 14.3065 19.9505 14.1938 19.9658 14.0075C19.9984 13.6076 20 13.0731 20 12.2V7.8C20 6.92692 19.9984 6.39239 19.9658 5.99247C19.9505 5.80617 19.9314 5.69345 19.9153 5.625C19.9076 5.59244 19.9012 5.57241 19.8973 5.56158C19.8936 5.55118 19.891 5.54601 19.891 5.54601C19.7951 5.35785 19.6422 5.20487 19.454 5.10899C19.454 5.10899 19.4488 5.10636 19.4384 5.10265C19.4276 5.09879 19.4076 5.09236 19.375 5.08469C19.3065 5.06857 19.1938 5.04945 19.0075 5.03423C18.6076 5.00156 18.0731 5 17.2 5Z"
      fill="#B151C9"
    />
  </svg>
);
const MusicNoteIconStyled = styled(MusicNoteIcon)`
  path {
    fill: var(--accent);
  }
`;

export const NextStepsBlock = () => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <StyledCard>
      <ThankYouSection>
        <H3>{t('thank-you-for-order')}</H3>
        <Progress />
        <ContentM>{t('delivery-bundle-ready')}</ContentM>
        <br />
        <BodyS>{t('delivery-bundle-ready-text')}</BodyS>
      </ThankYouSection>
      <NextStepsSection>
        <H3>{t('next-steps')}</H3>
        <Card>
          <CardOption
            onClick={() => {
              history.push('/library/releases');
            }}
          >
            <MusicNoteIconStyled />
            <H4>{t('view-release-details')}</H4>
            <div />
            <ChevronRightIcon />
          </CardOption>

          <CardOption
            onClick={() => {
              history.push('/library/artists/new/artist-page');
            }}
          >
            {viewdesktop}
            <H4>{t('create-an-artist-page')}</H4>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                history.push('/products/artist-hub');
              }}
              text={t('learn-more')}
              size="small"
            />
            <ChevronRightIcon />
          </CardOption>
        </Card>
      </NextStepsSection>
    </StyledCard>
  );
};
